<template>
<section v-if="hasPermissions(['Report Read', 'Report Write'])" class="view">
    <Breadcrumb :breadcrumb="breadcrumb" />
    <h1 class="view__title title--1" v-html="title_page" />
    <div class="view__description">
        <p class="view__description__text">
        </p>
    </div>
    <div>
        <FormDynamic 
            :form_format="form_format"
            :form_data="form_data"
            :array_options="array_options"
            :content_align_x="'hh'"
        />
    </div>
    <div class="tab-content mt-4" v-show="pdfSource">
        <div class="tab-pane fade active show" id="listation">
            <div class="row mb-0 no-gutters justify-content-md-center">
                <div class="col-lg-10" style="min-height: 60rem">
                    <v-card style="height: 100%">
                        <div>
                            <iframe style="width: 100%; height: 60rem;" :src="pdfSource"></iframe>
                        </div>
                    </v-card>
                </div>
            </div>
        </div>
    </div>
    <WaitingModal />
</section>

<div v-else>
    <UnauthorizedComponent :breadcrumb="breadcrumb" />
</div>
</template>

    
    
<script>
import axios from 'axios';
import Resources from './resources'
import FormResources from './form_resources'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import WaitingModal from '@/components/WaitingModal'
import UnauthorizedComponent from '@/components/UnauthorizedComponent'
import { Notyf } from 'notyf'
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'
import FormDynamic from '@/components/FormDynamic.vue';
const notyf = new Notyf({
    duration: 8000,
});

export default {

    name: "ProjectAssignmentReport",

    components: {
        Breadcrumb,
        WaitingModal,
        UnauthorizedComponent,
        FormDynamic
    },

    data() {
        return {
            notyf,
            axios,
            user: this.get_user(),
            rest_api: `search_standard_reports`,
            title_page: 'Project Assignment Report',
            current_url: `/reports`,
            breadcrumb: Resources.breadcrumb,
            form_format: FormResources.form_format_project_assignment,
            form_data: FormResources.form_data_project_assignment,
            rooms_report_table_headers: Resources.rooms_report_table_headers,
            rooms_report_table_headers_employee: Resources.rooms_report_table_headers_employee,
            search: '',
            first_request: true,
            pdfSource: '',
            array_options: {
                project_id: []
            }
        };
    },

    methods: {

        backToReports() {
            window.location.href = '/reports'
        },

        async getInitialData() {
            const form_data = {
                module_id: 7,
                first_request: true,
            }

            const response = await this.post('params_standard_reports', form_data)

            if (response.status) 
            {
                this.fill_data(response.data)
                
            } 
            else 
            {
                this.error_handling(response)
            }

            this.loader(false)

            return response.data
        },

        async fill_data(data)
        {
            this.array_options = {
                project_id: data.project_id
            }
        },

        async getReport() 
        {
            if(this.form_data.project_id)
            {
                const form_data = {
                    standard_report_id: 7,
                    id: this.form_data.project_id,
                    headers: this.form_data.supervisor_copy ? this.rooms_report_table_headers : this.rooms_report_table_headers_employee,
                    totals: Resources.rooms_report_totals,
                    format: this.form_data.format
                }

                this.loader(true)

                const response = await this.post('search_standard_reports', form_data)

                if (response.status) {
                    const base64Data = await this.downloadFile(response, true)
                    var blobUrl = URL.createObjectURL(base64Data);
                    this.pdfSource = blobUrl
                } else {
                    this.error_handling(response)
                }

                this.loader()
            }
        },

    },

    async mounted() {
        if (this.hasPermissions(['Report Read', 'Report Write'])) 
        {
            this.getInitialData()

            let supervisor_copy = true

            if(this.$route.query.supervisor_copy == 'false')
            {   
                supervisor_copy = false
            }

            console.log(supervisor_copy);

            if(this.$route.query.id)
            {
                this.form_data = {
                    project_id: this.$route.query.id,
                    supervisor_copy: supervisor_copy,
                    format: this.$route.query.format ? this.$route.query.format : 'portrait'
                }
                
            }
            else
            {
                this.form_data = {
                    supervisor_copy: supervisor_copy,
                    project_id: '',
                    format: 'portrait'
                }
            }

            console.log(supervisor_copy);
            console.log(this.form_data);
        }
    },

    watch: {
        form_data: {
            handler(val)
            {
                this.$router.replace({ 
                    path: 'project-assignment', 
                    query: { 
                        id: val.project_id,
                        supervisor_copy: val.supervisor_copy,
                        format: val.format
                    }
                }).catch(()=> {})

                this.getReport()
            },
            deep: true
         },
    }

}
</script>
